module.exports = __webpack_public_path__ + "img/kwait.07ccc6a2.svg";